module.exports = __webpack_public_path__ + "img/logo-white.2b3a4e20.png";